<div class="text-muted-color flex flex-wrap gap-4 text-xs">
  @for (entry of entries(); track entry.labelKey) {
    <span class="flex items-center gap-1">
      <span
        class="inline-block h-2.5 w-2.5 rounded-full"
        [style.backgroundColor]="entry.color"
      ></span>
      {{ entry.labelKey | transloco }}
    </span>
  }
  <ng-content />
</div>
